import { render, staticRenderFns } from "./SvcProvidersForm.vue?vue&type=template&id=4c2d4b94&"
import script from "./SvcProvidersForm.vue?vue&type=script&lang=js&"
export * from "./SvcProvidersForm.vue?vue&type=script&lang=js&"
import style0 from "./SvcProvidersForm.vue?vue&type=style&index=0&id=4c2d4b94&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports